module.exports = __webpack_public_path__ + "img/01-26-165.070a40a2.jpg";